import { render, staticRenderFns } from "./FetchFromApi.vue?vue&type=template&id=5c6516aa&"
import script from "./FetchFromApi.vue?vue&type=script&lang=js&"
export * from "./FetchFromApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports